export default __webpack_public_path__ + "static/media/notFound.3cd7b326.png";